namespace Roodik.Game
{
	import Slot = dragonBones.Slot;
	import Point = PIXI.Point;

	export class SimpleButton
	{
		public static readonly CLICKED: string = "Clicked";
		public events: PIXI.utils.EventEmitter;

		private _onDownHandler: () => void;
		private _onUpHandler: () => void;
		private _onOverHandler: () => void;
		private _onOutHandler: () => void;
		private _onUpOutsideHandler: () => void;

		private _up: Slot;
		private _over: Slot;
		private _hitArea: Slot;
		private _overTint: number;
		private _downTint: number;
		private _label: PIXI.Text;

		constructor(protected _container: any,
		            text?: string,
		            fontStyle?: PIXI.TextStyleOptions,
		            private _revertColor?: boolean,
		            private _anchor:Point = new Point(0,0))
		{
			this._overTint = 0xcccccc;
			this._downTint = 0x999999;

			this.events = new PIXI.utils.EventEmitter();

			this._up = _container.armature.getSlot("up");
			this._over = _container.armature.getSlot("over");
			this._hitArea = _container.armature.getSlot("hit");

			this._hitArea.display.interactive = true;
			this._hitArea.display.buttonMode = true;
			this._onDownHandler = this.onDown.bind(this);
			this._onUpHandler = this.onUp.bind(this);
			this._onOverHandler = this.onOver.bind(this);
			this._onOutHandler = this.onOut.bind(this);
			this._onUpOutsideHandler = this.onUpOutside.bind(this);
			this._hitArea.display.on("mousedown", this._onDownHandler);
			this._hitArea.display.on("mouseup", this._onUpHandler);
			this._hitArea.display.on("mouseover", this._onOverHandler);
			this._hitArea.display.on("mouseout", this._onOutHandler);
			this._hitArea.display.on("mouseupoutside", this._onUpOutsideHandler);

			this._hitArea.display.on("touchstart", this._onDownHandler);
			this._hitArea.display.on("touchend", this._onUpHandler);
			this._hitArea.display.on("touchendoutside", this._onUpOutsideHandler);

			if (text != '')
			{
				this._label = new PIXI.Text(text, fontStyle);
				this._label.x = Math.round(-this._label.width / 2.0) - this._anchor.x*(this._label.width / 2.0);
				this._label.y = Math.round(-this._label.height / 2.0) - this._anchor.y*(this._label.height / 2.0);
				_container.addChild(this._label);
			}

			this.updateVisualState("up");
		}

		public updateText(text:string)
		{
			if (this._label != null)
			{
				this._label.text = text;
			}
		}

		public set textPosition(value:PIXI.Point)
		{
			if (this._label != null)
			{
				this._label.x = Math.round(-this._label.width / 2.0) - this._anchor.x*(this._label.width / 2.0) + value.x;
				this._label.y = Math.round(-this._label.height / 2.0) - this._anchor.y*(this._label.height / 2.0) + value.y;
			}
		}

		private onDown(): void
		{
			this.updateVisualState("down");
		}

		protected onUp(): void
		{
			this.events.emit(SimpleButton.CLICKED);
			this.updateVisualState("up");
		}

		private onOver(): void
		{
			this.updateVisualState("over");
		}

		private onOut(): void
		{
			this.updateVisualState("out");
		}

		private onUpOutside(): void
		{
			this.updateVisualState("up");
		}

		private updateVisualState(state: string): void
		{
			let tint: number = 0xffffff;
			switch (state)
			{
				case "up":
					this._up.visible = true;
					this._over.visible = false;
					this._over.display.tint = tint = 0xffffff;
					break;
				case "down":
					this._over.display.tint = tint = this._downTint;
					this._up.visible = false;
					this._over.visible = true;
					break;
				case "over":
					this._over.display.tint = tint = this._overTint;
					this._up.visible = false;
					this._over.visible = true;

					if (this._revertColor)
					{
						let fillColor:string = this._label.style.fill.toString();
						this._label.style.fill = this._label.style.stroke;
						this._label.style.stroke = fillColor;
						this._label.style.dropShadowColor = fillColor;
					}

					break;
				case "out":
					this._over.display.tint = tint = 0xffffff;
					this._up.visible = true;
					this._over.visible = false;

					if (this._revertColor)
					{
						let strokeColor:string = this._label.style.stroke.toString();
						this._label.style.stroke = this._label.style.fill.toString();
						this._label.style.dropShadowColor = this._label.style.fill.toString();
						this._label.style.fill = strokeColor;
					}

					break;
			}
			if (this._label)
			{
				this._label.tint = tint;
			}
		}

		public get container(): any
		{
			return this._container;
		}

		public set alpha (value:number)
		{
			this._container.alpha = value;
		}

		public destroy()
		{
			if (this._label)
			{
				this._container.removeChild(this._label);
				this._label.destroy();
			}

			this._hitArea.display.off("touchstart", this._onDownHandler);
			this._hitArea.display.off("touchend", this._onUpHandler);
			this._hitArea.display.off("touchendoutside", this._onUpOutsideHandler);

			this._hitArea.display.off("mousedown", this._onDownHandler);
			this._hitArea.display.off("mouseup", this._onUpHandler);
			this._hitArea.display.off("mouseover", this._onOverHandler);
			this._hitArea.display.off("mouseout", this._onOutHandler);
			this._hitArea.display.off("mouseupoutside", this._onUpOutsideHandler);
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Core/Controls/SimpleButton.ts